"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classifierHashColumns = exports.classifierHashEntityName = exports.classifierColumns = exports.classifierSchema = exports.partialClassifierSchema = exports.classifierStatuses = void 0;
const storage_1 = require("@juvare/platform-shared/features/storage");
const zod_1 = require("zod");
exports.classifierStatuses = ['active', 'deprecated', 'retired'];
exports.partialClassifierSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(1),
    status: zod_1.z.enum(exports.classifierStatuses),
    form: zod_1.z.record(zod_1.z.any()).optional(),
});
exports.classifierSchema = exports.partialClassifierSchema.merge(zod_1.z.object({
    default: exports.partialClassifierSchema.optional(),
}));
exports.classifierColumns = (0, storage_1.defineColumns)({
    name: {
        type: 'string-required',
        index: 'unique',
    },
    status: {
        type: 'string-required',
        index: true,
    },
    defaultName: {
        type: 'string',
        index: true,
    },
});
exports.classifierHashEntityName = 'classifierHash';
exports.classifierHashColumns = (0, storage_1.defineColumns)({
    classifierName: {
        type: 'string-required',
        index: true,
    },
    hash: {
        type: 'string-required',
    },
});
